import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorMessage } from '@/shared/utils/error';
import type { ConsultarOrigemInput, OrigemPedidoResultado } from '../../types/origemPedidoTypes';
import { origemPedidoService } from './services';

export const consultarOrigemPedido = createAsyncThunk<
  OrigemPedidoResultado,
  ConsultarOrigemInput,
  { rejectValue: string }
>('origemPedido/consultar', async (input, { rejectWithValue }) => {
  try {
    return await origemPedidoService.consultar(input);
  } catch (error) {
    return rejectWithValue(getErrorMessage(error));
  }
});
